import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";

import { Trade } from "../../types/models/Trade";

type MyTradeState = {
  myTrades: { [key: string]: Trade[] };
  detailDialog: boolean;
  detail?: Trade;
};

const initialState: MyTradeState = {
  myTrades: {},
  detailDialog: false,
  detail: undefined,
};

export const mytradeSlice = createSlice({
  name: "mytrade",
  initialState,
  reducers: {
    setMyTrades: (state, action: PayloadAction<Trade[]>) => {
      const myTrades = action.payload;
      if (myTrades && myTrades.length > 0) {
        const groupedResult = _.groupBy(myTrades, (trade: Trade) => {
          const date = new Date(trade?.closingTime);
          return `${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
        }) as { [key: string]: Trade[] };
        state.myTrades = groupedResult;
      } else {
        state.myTrades = {};
      }
    },
    toggleDetailDialog: (state) => {
      state.detailDialog = !state.detailDialog;
    },
    setMyTradeDetail: (state, action: PayloadAction<Trade>) => {
      const myTrade = action.payload;
      state.detail = myTrade;
    },
  },
});

export const myTradeActions = mytradeSlice.actions;
